import {
  useRef, MutableRefObject, memo, PropsWithChildren,
} from 'react';

import Controller from '../lib/Controller';
import { useFlipbook, FlipbookContext } from '../lib/hooks';

import styles from './Item.module.css';

type ItemProps = {
  controllerRef?: MutableRefObject<Controller | undefined>
};

const Item = (props: PropsWithChildren<ItemProps>) => {
  const {
    children,
    controllerRef,
  } = props;
  const divRef = useRef<HTMLDivElement>(null);

  const {
    pageId, isVisible, isOpened,
  } = useFlipbook(divRef);

  const contextValue = {
    pageId,
    controllerRef,
    isVisible,
    isOpened,
  };

  return (
    <FlipbookContext.Provider value={contextValue}>
      <div
        ref={divRef}
        className={styles.page}
      >
        {isVisible && children}
      </div>
    </FlipbookContext.Provider>
  );
};

export default memo(Item);
